// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"settings_wrapper___oi5H","container":"settings_container__vJvm9","body":"settings_body__SwTuT","title":"settings_title__u_yog","mainTitle":"settings_mainTitle__ypS3c"};